<template>
  <div id="goodsPurchaseDetail">
    <div class="invoicingHead" style="height:40px;">
      <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <a
            @click="jumpTT('/invoicingFather/stockFlowList')"
            href="javascript:;"
            >库存流水</a
          >
        </el-breadcrumb-item>
        <el-breadcrumb-item>进货单详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="invoicingHeadDown">
      <!-- 进货退货单详情资料 -->
      <div class="goodsDetail">
        <div>进货单详情</div>
        <div class="info">
          <div style="width: 15%">
            <div>单号：{{ list.orderCode }}</div>
            <div>业务日期：{{ list.businessTime }}</div>
            <div>经手人：{{ list.handlerName }}</div>
            <div>供应商：{{ list.supplierName }}</div>
          </div>
          <div style="width: 15%">
            <div>入库仓库：{{ list.repositoryName }}</div>
            <div>其它费用：￥{{ list.otherFree }}</div>
            <div>本单应付：￥{{ list.accountPayable }}</div>
            <div>结算账户：{{ list.settlementMethod == 1 ? "现金" : "" }}</div>
          </div>
          <div style="width: 25%">
            <div>实付金额：￥{{ list.accountPayable }}</div>
            <div>
              整单备注：{{
                list.purchaseRemark == "" ? "无" : list.purchaseRemark
              }}
            </div>
          </div>
          <div style="width: 30%">
            <div>图片附件：</div>
            <div>
              <el-upload
                action="http://192.168.1.33:8888/ImageServer/YmUpload_image"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
                :http-request="loadImg"
                :show-file-list="true"
                :file-list="fileList"
                :class="{ hide: hideUpload }"
                :limit="3"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </div>
          </div>
          <div style="width: 15%">
            <el-button
              type="primary"
              plain
              size="small"
              @click="voucherDialogVisible = true"
              >查看单据</el-button
            >
            <el-button
              type="primary"
              size="small"
              v-if="isDestroy == 0 && bools == false"
              @click="destroyRefundGoods"
              >作废</el-button
            >
            <el-button
              type="primary"
              size="small"
              v-if="isDestroy == 0 && bool == false"
              @click="putinStock"
              >入库</el-button
            >
          </div>
        </div>
      </div>
      <div class="title">进货商品</div>
      <!-- 表格 -->
      <div style="width: calc(100vw - 250px);">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column
            align="center"
            prop="goodsName"
            label="进货商品"
            width="180"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="valueContent"
            label="规格"
          ></el-table-column>
          <el-table-column align="center" prop="takePrice" label="进货价">
            <template slot-scope="scope">
              ￥{{ scope.row.takePrice }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="goodsUnit"
            label="单位"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="goodsNum"
            label="数量"
          ></el-table-column>
          <el-table-column align="center" prop="inStorageStatus" label="状态">
            <template slot-scope="scope">
              <div
                style="width:60px;height:30px;line-height:30px;border-radius:10px;border: 1px solid #ccc;margin:auto;color:#ccc;font-size:10px;"
                v-if="scope.row.inStorageStatus == 0"
              >
                未入库
              </div>
              <div
                style="width:60px;height:30px;line-height:30px;border-radius:10px;border: 1px solid #FDB99E;margin:auto;color:#FDB99E;font-size:10px;"
                v-if="scope.row.inStorageStatus == 1"
              >
                入库
              </div>
              <div
                style="width:60px;height:30px;line-height:30px;border-radius:10px;border: 1px solid #6ABCF8;margin:auto;color:#6ABCF8;font-size:10px;"
                v-if="scope.row.inStorageStatus == 2"
              >
                部分入库
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="totalTakePrice" label="总价">
            <template slot-scope="scope">
              ￥{{ scope.row.totalTakePrice }}
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <!-- <div v-if="tableData.length > 0" style="float:right;margin-top:10px;">
                  <el-pagination
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
                    :current-page="queryInfo.pageNum"
                    :page-size="queryInfo.pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="total"
                  ></el-pagination>
                </div> -->
      </div>
    </div>
    <!-- 单据 -->
    <el-dialog
      :visible.sync="voucherDialogVisible"
      width="16%"
      :before-close="handleVoucherClose"
    >
      <span>
        <div class="shopName">{{ shopInformation.shopName }}</div>
        <div class="voucherTitle shopName mb20">
          <span class="line"></span>
          <span>进货单</span>
          <span class="lines"></span>
        </div>
        <div class="dottedLine"></div>
        <div class="dottedLine"></div>
        <div class="mt20 mb20">
          <div class="mb5">入库仓库：{{ list.repositoryName }}</div>
          <div class="mb5">供应商：{{ list.supplierName }}</div>
          <div class="mb5">经手人：{{ list.handlerName }}</div>
          <div class="mb5">单号：{{ list.orderCode }}</div>
          <div>日期：{{ list.businessTime }}</div>
          <div v-if="list.newestRuTime">
            最新入库时间：{{ list.newestRuTime.substr(0, 16) }}
          </div>
        </div>
        <div class="dashedLine mb20"></div>
        <div class="mb5">商品名称/规格</div>
        <div class="flex-betweens">
          <div class="mb5" style="width: 23%;text-align: left;">单价(元)</div>
          <div class="mb5" style="width: 25%;text-align: center;">
            数量/单位
          </div>
          <div class="mb5" style="width: 23%;text-align: right;">合计(元)</div>
        </div>
        <div
          class="flex-between"
          v-for="(item, index) in tableData"
          :key="index"
        >
          <div class="mb5" style="width: 35%;">
            {{ item.goodsName }}/{{ item.valueContent }}
          </div>
          <div class="flex-betweens mb20">
            <div style="width: 30%;text-align: left;">{{ item.takePrice }}</div>
            <div style="width: 30%;text-align: center;">
              {{ item.goodsNum }}/{{ item.goodsUnit }}
            </div>
            <div class="mb5" style="width: 30%;text-align: right;">
              {{ (item.goodsNum * item.takePrice).toFixed(2) }}
            </div>
          </div>
        </div>
        <div class="dashedLine mb20"></div>
        <div class="mt20 mb20">
          <div class="flex-betweens">
            <div class="mb5">合计：{{ totalLength }}</div>
            <div class="mb5">
              ￥{{ (list.accountPayable - list.otherFree).toFixed(2) }}
            </div>
          </div>
          <div class="mb5">其它费用：￥{{ list.otherFree }}</div>
          <div>结算账户：现金</div>
        </div>
        <div class="dashedLine mb20"></div>
        <div class="mb20">
          <div class="mb5">应付金额：￥{{ list.accountPayable }}</div>
          <div class="mb5">实付金额：￥{{ list.accountPayable }}</div>
          <div>
            备注：{{ list.purchaseRemark ? list.purchaseRemark : "无" }}
          </div>
        </div>
        <div class="dottedLine"></div>
        <div class="dottedLine"></div>
        <div class="shopName mt20">谢谢惠顾！</div>
      </span>
    </el-dialog>
    <!-- 友情提示：该仓库未锁定，锁定后才能盘点 -->
    <div v-show="lockWarn" class="lockWarn">
      <div><img src="../../assets/icon/jjb.png" class="warn-img" /></div>
      <div class="mt22" style="color:#555;font-size:18px;">友情提示</div>
      <div class="mt22" style="color:#999;font-size:16px;width:300px;">
        原单据中的仓库正在盘点，请解锁该仓库后再进行此操作！
      </div>
      <div style="margin-top:20px;">
        <el-button
          type="primary"
          plain
          @click="(lockWarn = false), (mask = false)"
          >取消</el-button
        >
        <el-button type="primary" @click="quickUnlock">快捷解锁</el-button>
      </div>
    </div>
    <div class="mask" v-show="mask"></div>
  </div>
</template>

<script>
import {
  uploadImg,
  singleGoodsPurchase,
  destroygoodsPurchase,
  enterGoodsPurchaseNotAll,
  lockRepository
} from "../api";
export default {
  data() {
    return {
      shopInformation: {},
      userList: {},
      dialogVisible: false,
      dialogImageUrl: "",
      tableData: [],
      queryInfo: {
        pageNum: 1,
        pageSize: 10
      },
      orderId: "",
      isDestroy: "",
      voucherDialogVisible: false,
      list: {
        orderCode: "",
        businessTime: "",
        handlerName: "",
        supplierName: "",
        repositoryName: "",
        otherFree: "",
        accountRefundPayable: "",
        refundRemark: "",
        settlementMethod: "",
        goodsName: "",
        totalTakePrice: "",
        takePrice: ""
      },
      totalLength: 0,
      arr: {},
      bool: false,
      lockWarn: false,
      mask: false,
      fileList: [],
      hideUpload: false,
      bools: false
    };
  },
  created() {
    let shopInformation = JSON.parse(this.getCookie("shopInformation"));
    console.log(shopInformation, userList);
    this.shopInformation = shopInformation;
    let userList = JSON.parse(this.getCookie("userList"));
    this.userList = userList;
    // console.log(localStorage.getItem("orderId"))
    this.arr = JSON.parse(localStorage.getItem("detail") || "[]");
    console.log(this.arr);
    this.orderId = this.arr.orderId;
    this.isDestroy = this.arr.isDestroy;
    this.getSingleGoodsPurchaseList();
    this.hideUpload = true;
  },
  methods: {
    //跳转
    jumpTT(adress, message) {
      this.$router.push({ path: adress, query: { docId: message } });
    },
    // 快捷解锁
    quickUnlock() {
      lockRepository({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        isManager: 1,
        repositoryId: this.list.repositoryId,
        isLock: 0
      }).then(res => {
        if (res.code == 1) {
          this.$router.push("/invoicingFather/putGoodsInStock");
          this.$message.success("该仓库解锁成功");
        }
      });
      this.lockWarn = false;
      this.mask = false;
    },
    // 删除图片
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    // 图片放大
    handlePictureCardPreview(file) {
      console.log(file);
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 上传商品图片
    loadImg(res) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      imgUploadForm.append("fileContentType", res.file.type);
      imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      uploadImg(imgUploadForm)
        .then(res => {
          console.log(res);
          if (res.data.code == 1) {
            this.$message({
              message: res.data.msg,
              type: "success"
            });
            this.dialogImageUrl = res.data.data.url;
          } else if (res.data.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(res => {});
    },
    // 获取进货单详情列表
    getSingleGoodsPurchaseList() {
      singleGoodsPurchase({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        isManager: 1,
        pageNo: this.queryInfo.pageNum,
        row: this.queryInfo.pageSize,
        orderId: this.orderId
      }).then(res => {
        if (res.code == 1) {
          this.tableData = res.data.productJson;
          this.list = res.data;
          this.tableData.forEach(element => {
            this.totalLength += Number(element.goodsNum);
          });
          var imgList = res.data.photoAppendix.split(",");
          console.log(imgList, "imgList");
          imgList.forEach(item => {
            if (item) {
              this.fileList.unshift({ name: "", url: item });
            }
          });
          for (var i = 0; i < this.tableData.length; i++) {
            this.list.goodsName = this.tableData[i].goodsName;
            this.list.takePrice = this.tableData[i].takePrice;
            this.list.totalTakePrice = this.tableData[i].totalTakePrice;
          }
          this.bool = this.tableData.every((item, index, array) => {
            return item.inStorageStatus == 1;
          });
          this.bools = this.tableData.some(item => {
            return item.inStorageStatus == 1 || item.inStorageStatus == 2;
          });
          console.log(this.bools);
        } else if (res.code == -1) {
          this.tableData = [];
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 分页
    // handleCurrentChange(newVal) {

    // },
    // handleSizeChange(newVal) {

    // }
    // 作废
    destroyRefundGoods() {
      destroygoodsPurchase({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        isManager: 1,
        orderId: this.orderId
      }).then(res => {
        if (res.code == 1) {
          this.$message.success(res.msg);
          this.$router.push("/invoicingFather/stockFlowList");
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleVoucherClose() {
      this.voucherDialogVisible = false;
    },
    // 入库
    putinStock() {
      console.log(this.list.isLock, "isLock");
      if (this.list.isLock == 1) {
        this.lockWarn = true;
        this.mask = true;
        return;
      }
      this.$router.push("/invoicingFather/putGoodsInStock");
      localStorage.setItem("inStockStyle", 3);
    }
  }
};
</script>

<style scoped>
.warn-img {
  width: 68px;
  height: 68px;
}
.lockWarn {
  width: 394px;
  height: 305px;
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  position: absolute;
  z-index: 3;
  top: 220px;
  left: 700px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 20px 0;
  box-sizing: border-box;
}
.mask {
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(101, 101, 101, 0.6);
}
.mt22 {
  margin-top: 22px;
}
.flex-start {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.flex-betweens {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.flex-between {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.flex-between:last-child {
  text-align: right;
}
.mb5 {
  margin-bottom: 5px;
}
.mt20 {
  margin-top: 20px;
}
.mb20 {
  margin-bottom: 20px;
}
.dottedLine {
  border: 1px dotted #ccc;
  margin-top: 5px;
}
.dashedLine {
  border: 1px dashed #ccc;
  margin-top: 5px;
}
.line {
  width: 88px;
  height: 1px;
  background-color: #ccc;
  display: block;
  position: absolute;
  top: 111px;
}
.lines {
  width: 88px;
  height: 1px;
  background-color: #ccc;
  display: block;
  position: absolute;
  left: 195px;
  top: 111px;
}
.shopName {
  font-size: 18px;
  text-align: center;
  color: #000;
}
.voucherTitle {
  padding-top: 15px;
  font-size: 18px;
}
.goodsDetail {
  width: calc(100vw - 280px);
  height: auto;
  background-color: #f8f8f8;
  padding: 20px;
}
.info {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding-top: 20px;
  box-sizing: border-box;
  font-size: 14px;
  color: #737373;
}
.title {
  width: calc(100vw - 245px);
  height: 50px;
  line-height: 50px;
  margin: 20px auto;
  background-color: #f8f8f8;
  font-size: 15px;
  padding-left: 20px;
  box-sizing: border-box;
}
::v-deep .el-table th {
  background-color: #f8f8f8;
  margin-top: 20px;
}
</style>
<style>
.el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 100px;
  margin-top: 10px;
}
.el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
  line-height: 100px;
  margin-top: 10px;
}
/* .el-table th {
    background-color: #F2F3F2;
    margin-top: 20px;
} */
.el-dialog__headerbtn .el-dialog__close {
  display: none;
}
.hide .el-upload--picture-card {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/page/stockFlowDetail.vue